var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { autoinject } from 'aurelia-framework';
import { TokenClient } from '../authentication/token-client.service';
import { RequestClient } from '../basics/request-client.service';
import { Md5 } from '../../utilities/md5';
import { toNative } from '../../utilities/promise-utils';
var ConfigClientService = /** @class */ (function () {
    function ConfigClientService(tokenClient, requestClient) {
        this.tokenClient = tokenClient;
        this.requestClient = requestClient;
        this.cachedJSON = {};
    }
    ConfigClientService.prototype.getClientConfig = function (assetName) {
        var user = this.tokenClient.user;
        var isPreview = this.tokenClient.isPreview;
        var isClient = this.tokenClient.isClient();
        var isWidget = this.tokenClient.isWidget;
        var brandName = user.brandName ? user.brandName.toLowerCase() : null;
        var templateName = user.templateName.toLowerCase();
        var themeName = user.themeName ? user.themeName.toLowerCase() : isPreview ? "preview" : 'active-theme';
        var templates = isWidget ? "widgets" : "templates";
        var result = null;
        if ((isPreview || isClient) && brandName) { // this is for brand admins
            result = this.requireJSON("app/styles/client/brandings/".concat(brandName, "/config/").concat(themeName, "-").concat(templateName, "/").concat(assetName, ".json"), "app/styles/client/".concat(templates, "/").concat(templateName, "/config/").concat(themeName, "/").concat(assetName, ".json"), "app/styles/client/".concat(templates, "/").concat(templateName, "/config/active-theme/").concat(assetName, ".json"), true);
        }
        else if (isPreview) { // this is for super admins
            result = this.requireJSON("app/styles/client/".concat(templates, "/").concat(templateName, "/config/").concat(themeName, "/").concat(assetName, ".json"), null, null, true);
        }
        if (result == null) //fallback
            result = this.requireJSON("app/styles/client/".concat(templates, "/").concat(templateName, "/config/active-theme/").concat(assetName, ".json"), null, null, true);
        return result;
    };
    ConfigClientService.prototype.requireJSON = function (path, templateTheme, defaultPath, shouldCache) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.requireJSONAndMd5Hash(path, templateTheme, defaultPath, shouldCache)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result.model];
                }
            });
        });
    };
    ConfigClientService.prototype.requireJSONAndMd5Hash = function (path, templateTheme, defaultPath, shouldCache) {
        return __awaiter(this, void 0, void 0, function () {
            var files, prefixUrl, azureStoragePath, json, md5, templateThemePath, defaultAzureStoragePath, templateThemeJson, defaultJson, _a, clonedDefaultJson;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        files = 'files';
                        prefixUrl = this.tokenClient.isDevelopment ? '' : (this.tokenClient.storageUri + files);
                        azureStoragePath = prefixUrl + '/dist/' + this.tokenClient.versionNumber + '/config/ClientApp/' + path;
                        return [4 /*yield*/, this.requireJSONRequest(azureStoragePath, shouldCache)];
                    case 1:
                        json = _b.sent();
                        md5 = json ? Md5.hashStr(JSON.stringify(json)) : null;
                        if (!(templateTheme && defaultPath)) return [3 /*break*/, 6];
                        templateThemePath = prefixUrl + '/dist/' + this.tokenClient.versionNumber + '/config/ClientApp/' + templateTheme;
                        defaultAzureStoragePath = prefixUrl + '/dist/' + this.tokenClient.versionNumber + '/config/ClientApp/' + defaultPath;
                        return [4 /*yield*/, this.requireJSONRequest(templateThemePath, shouldCache)];
                    case 2:
                        templateThemeJson = _b.sent();
                        if (!templateThemeJson) return [3 /*break*/, 3];
                        _a = templateThemeJson;
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.requireJSONRequest(defaultAzureStoragePath, shouldCache)];
                    case 4:
                        _a = _b.sent();
                        _b.label = 5;
                    case 5:
                        defaultJson = _a;
                        clonedDefaultJson = JSON.parse(JSON.stringify(defaultJson));
                        json = json ? this.merge(clonedDefaultJson, json) : clonedDefaultJson;
                        _b.label = 6;
                    case 6: return [2 /*return*/, {
                            md5Hash: md5 ? md5.toString() : null,
                            model: json ? json : {} // fix for templates having missing json files due to difference in implementation
                        }];
                }
            });
        });
    };
    ConfigClientService.prototype.merge = function (defaultObj, brandObj) {
        var e_1, _a;
        if (Array.isArray(defaultObj)) {
            if (brandObj == null || brandObj == undefined)
                return defaultObj;
            try {
                for (var brandObj_1 = __values(brandObj), brandObj_1_1 = brandObj_1.next(); !brandObj_1_1.done; brandObj_1_1 = brandObj_1.next()) {
                    var item = brandObj_1_1.value;
                    var key = item.key;
                    var obj = defaultObj.filter(function (x) { return x.key == key; })[0];
                    var isDefault = false;
                    if (!obj) {
                        isDefault = true;
                        var defaultItem = defaultObj.filter(function (x) { return x.key == "default"; });
                        obj = defaultItem && defaultItem[0] ? JSON.parse(JSON.stringify(defaultItem[0])) : null;
                    }
                    var difference = this.merge(obj, item);
                    if (difference != null) {
                        if (obj && !isDefault)
                            defaultObj.splice(defaultObj.indexOf(obj), 1);
                        defaultObj.push(difference);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (brandObj_1_1 && !brandObj_1_1.done && (_a = brandObj_1.return)) _a.call(brandObj_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return defaultObj;
        }
        else if (Object.prototype.toString.call(defaultObj).toLowerCase() == "[object object]") {
            if (defaultObj == null || defaultObj == undefined)
                return brandObj;
            for (var x in brandObj) {
                var difference = this.merge(defaultObj[x], brandObj[x]);
                if (difference != null) {
                    defaultObj[x] = difference;
                }
            }
            return defaultObj;
        }
        else {
            if (defaultObj == brandObj)
                return null;
            return brandObj;
        }
    };
    ConfigClientService.prototype.requireJSONRequest = function (azureStoragePath, shouldCache) {
        return __awaiter(this, void 0, void 0, function () {
            var timeNow, json, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        if (shouldCache && this.cachedJSON[azureStoragePath] !== undefined) {
                            return [2 /*return*/, this.cachedJSON[azureStoragePath]];
                        }
                        timeNow = Date.now();
                        return [4 /*yield*/, toNative(this.requestClient.get(azureStoragePath, { version: timeNow }, true, false, null, {}))];
                    case 1:
                        json = _b.sent();
                        if (shouldCache) {
                            this.cachedJSON[azureStoragePath] = json;
                        }
                        return [2 /*return*/, json];
                    case 2:
                        _a = _b.sent();
                        return [2 /*return*/, null];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ConfigClientService.prototype.invalidateCache = function (paths) {
        this.cachedJSON = {};
    };
    ConfigClientService = __decorate([
        autoinject(),
        __metadata("design:paramtypes", [TokenClient, RequestClient])
    ], ConfigClientService);
    return ConfigClientService;
}());
export { ConfigClientService };
var RequireJSONResponse = /** @class */ (function () {
    function RequireJSONResponse() {
    }
    return RequireJSONResponse;
}());
export { RequireJSONResponse };
